import { Controller } from "@hotwired/stimulus"

// Toggles the Savant Console between the dark Monaco palette and the editorial
// light palette. Flips the <html> class for an instant, flash-free switch, then
// persists the choice to the user's account so it sticks on the next load and
// follows them across devices. The sun/moon icons are CSS-driven off the same
// <html> class (see the sidebar partial), so they always match — including the
// server-rendered first paint. Theme-aware controllers (e.g. charts) react to
// the dispatched "theme:changed" event.
export default class extends Controller {
  static values = { url: String }

  toggle() {
    const next = document.documentElement.classList.contains("light") ? "dark" : "light"
    this.apply(next)
    this.persist(next)
  }

  apply(theme) {
    const root = document.documentElement
    root.classList.toggle("light", theme === "light")
    root.classList.toggle("dark", theme === "dark")

    const label = theme === "light" ? "Switch to dark mode" : "Switch to light mode"
    this.element.setAttribute("aria-label", label)
    this.element.setAttribute("title", label)

    window.dispatchEvent(new CustomEvent("theme:changed", { detail: { theme } }))
  }

  persist(theme) {
    if (!this.hasUrlValue) return

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": this.csrfToken(),
        Accept: "application/json"
      },
      body: JSON.stringify({ theme })
    }).catch(() => {
      // A network failure must not break the visual toggle; the only cost is
      // that the choice won't be remembered on the next reload.
    })
  }

  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ""
  }
}
